import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Info } from "lucide-react";

export function InfoTip({ children, side = "top", align = "start" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label="More information" data-testid="info-tip"
          className="inline-flex items-center justify-center h-5 w-5 rounded-full text-ink-400 hover:text-redline-600 hover:bg-redline-50 transition-colors align-middle shrink-0">
          <Info className="h-3.5 w-3.5" strokeWidth={2.25} />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} align={align} className="w-72 text-[13px] text-ink-700 leading-relaxed">
        {children}
      </PopoverContent>
    </Popover>
  );
}
